import { showToast } from 'components/Toast';
import { baseApi } from 'services/baseApi';
import {
  buildDonorsUrl,
  transformDonorsResponse,
  getDonorsErrorMessage,
} from 'services/donors/helpers';
import { DonorsQueryParams, IDonorData } from 'services/donors/types';
import { isAbortError } from 'helpers/rtk-utils';

export const donorsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getDonors: builder.query<IDonorData, DonorsQueryParams>({
      query: buildDonorsUrl,
      transformResponse: transformDonorsResponse,
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          if (isAbortError(err)) {
            return;
          }
          showToast(getDonorsErrorMessage(err), 'error');
        }
      },
      providesTags: ['Donors'],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDonorsQuery, useLazyGetDonorsQuery } = donorsApi;
